<!-- =========================================================================================
    File Name: V2Sidebar.vue
    Description: .
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="v2_sidebar_container">
    <div
      v-if="isSidebarOpen && isMobile"
      class="v2_sidebar_backdrop"
      @click="toggleSidebar"
    ></div>

    <aside
      id="v2_page_sidebar"
      class="v2_sidebar_wrapper"
      :data-is-sidebar-open="isSidebarOpen"
    >
      <div class="v2_sidebar_content">
        <template v-if="isMobile">
          <div class="h-10 w-full flex items-center justify-between">
            <img
              :src="companyLogo"
              alt="Logo Bem Protege"
              class="v2_sidebar_img"
            />

            <button class="v2_header_sidebar_btn" @click="toggleSidebar">
              <vs-icon
                class="text-2xl"
                icon-pack="feather"
                icon="icon-x"
                color="white"
              ></vs-icon>
            </button>
          </div>
        </template>
        <template v-else>
          <button
            v-if="!isMobile"
            class="v2_sidebar_toggle_btn"
            @click="toggleSidebar"
          >
            <vs-icon
              class="text-md"
              icon-pack="feather"
              icon="icon-sidebar"
              color="white"
            ></vs-icon>
          </button>
        </template>

        <nav>
          <router-link
            to="/dashboard"
            class="v2_sidebar_nav_link"
            exact
            v-if="$can($actionsDefault.Leitura, 'Dashboard')"
          >
            <vs-icon
              class="text-md"
              icon-pack="feather"
              icon="icon-home"
              color="white"
            ></vs-icon>

            <span>Meu Painel</span>
          </router-link>

          <div
            :key="sidebarItem.name"
            class="v2_sidebar_section"
            v-for="sidebarItem in filteredSidebarItems"
          >
            <template v-if="isSidebarOpen">
              <span class="v2_sidebar_section_title">{{
                sidebarItem.name
              }}</span>
            </template>
            <template v-else>
              <vs-icon
                class="v2_sidebar_section_icon"
                icon-pack="feather"
                icon="icon-minus"
                color="#87A3BF"
              ></vs-icon>
            </template>

            <ul class="v2_sidebar_section_list">
              <li :key="route.path" v-for="route in sidebarItem.routes">
                <router-link
                  :to="route.path"
                  class="v2_sidebar_nav_link"
                  exact
                  v-if="$can($actionsDefault.Leitura, route.subject)"
                >
                  <vs-icon
                    class="text-md"
                    icon-pack="feather"
                    :icon="route.icon"
                    color="white"
                  ></vs-icon>

                  <span>{{ route.name }}</span>
                </router-link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </aside>
  </div>
</template>

<script>
import sidebarItems from '../constants/sidebarItems';

export default {
  props: {
    isMobile: {
      type: Boolean,
      required: true,
    },
    isSidebarOpen: {
      type: Boolean,
      required: true,
    },
    companyLogo: {
      type: String,
      required: true,
    },
    toggleSidebar: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      sidebarItems,
    };
  },

  computed: {
    filteredSidebarItems() {
      return this.sidebarItems.filter((item) => {
        return item.routes.some((route) => this.$can('Leitura', route.subject));
      });
    },
  },
};
</script>

<style lang="scss">
.v2_sidebar_wrapper {
  height: 100%;
  width: 72px;
  background-color: #082440;
  padding: 8px 16px 16px 16px;
  overflow-y: auto;
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transform: translate(0);

  &::-webkit-scrollbar {
    display: none;
  }

  &[data-is-sidebar-open='true'] {
    width: 240px;

    .v2_sidebar_nav_link span {
      opacity: 1;
    }
  }

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000000;
    transform: translate(-100%);

    &[data-is-sidebar-open='true'] {
      transform: translate(0);
    }
  }
}

.v2_sidebar_backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999999;
  background-color: transparent;
}

.v2_sidebar_img {
  height: 100%;
  max-width: 100px;
  object-fit: contain;
}

.v2_sidebar_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}

.v2_sidebar_toggle_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 8px;
  background-color: transparent;
  outline: transparent;
  border: 0;
  cursor: pointer;
}

.v2_sidebar_content nav {
  width: 100%;
}

.v2_sidebar_nav_link {
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  padding: 12px;
  color: white;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:visited {
    color: white;
  }

  &:hover {
    color: white;
    background-color: #145699;
  }

  &[aria-current='page'] {
    background-color: #114880;
  }
}

.v2_sidebar_nav_link span {
  transition-property: opacity;
  transition-duration: 300ms;
  transition-timing-function: linear;
  opacity: 0;
}

.v2_sidebar_section {
  display: flex;
  flex-direction: column;
}

.v2_sidebar_section_title {
  color: #87a3bf;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  padding: 24px 0px 12px 12px;
}

.v2_sidebar_section_icon {
  padding: 30px 0px 12px 0px;
}

.v2_sidebar_section_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
